import * as React from 'react';
import {getReactButton} from "../../index";
import {ReactButtonState} from "./ReactButton";
import {RefObject} from "react";

interface ReactAccordionData {
    id?: string,
    text?: {},
    content?: {},
    style?: {},
    css?: string,
    expandedCSS?: string,
    expandedStyle?: {},
    contentStyle?: {},
    contentCSS?: string,
    dataKey: string,
    row: any,
    rowIndex: number,
    onClick: (rowObj: any, shiftKey: boolean, ctrlKey: boolean, rowIndex: number) => boolean,
    tabIndex?: null,
    refreshID?: string,
    onRefresh?: () => {},
    title?: string,
    expandedID?: string,
    stopPropagationOnClick?: boolean,
    disabled?: boolean,
    disableID?: string,
    arrowExpandCSS?: string,
    arrowCollapseCSS?: string,
    arrowStyle?: {},
    enableDragAndDrop?: boolean,
    shellID?: string,
    onDragStart?: (event: React.DragEvent<HTMLTableRowElement>, row: any) => void,
    onDragStop?: (event: React.DragEvent<HTMLTableRowElement>) => void,
    onDuringDrag?: (event: React.DragEvent<HTMLTableRowElement>, row: any) => void,
    collapsedCSS?: string,
    collapsedStyle?: {},
    allowExpandAndCollapse?: boolean,
}

interface ReactAccordionState {
    row: any,
    disabled: boolean,
    content: {},
}

export class ReactAccordion extends React.Component<ReactAccordionData> {
    allowExpandAndCollapse: boolean;

    constructor(props: ReactAccordionData) {
        super(props);

        this.state = {
            content: props.content,
            disabled: (props.disabled),
            row: props.row,
        };

        this.allowExpandAndCollapse = (null != props.allowExpandAndCollapse) ? props.allowExpandAndCollapse : true;

        // Binding is necessary to allow these functions access to the State data
        this.hideShowAccordion = this.hideShowAccordion.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onExpandedClick = this.onExpandedClick.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.startDragRow = this.startDragRow.bind(this);
        this.stopDragRow = this.stopDragRow.bind(this);
        this.duringDragRow = this.duringDragRow.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactAccordionData) {
        this.setState({
            content: props.content,
            disabled: props.disabled,
            row: props.row,
        });
    }

    getAccordionIcon() {
        if(!this.allowExpandAndCollapse || (Object.keys(this.props.content).length <= 0)) {
            return "";
        } else if((this.state as ReactAccordionState).row[this.props.dataKey]) {
            return this.props.arrowExpandCSS;
        }
        else {
            return this.props.arrowCollapseCSS;
        }
    }

    hideShowAccordion(event: React.MouseEvent<HTMLInputElement, MouseEvent>) {
        if(this.allowExpandAndCollapse) {
            const isExpanded = this.props.onClick((this.state as ReactAccordionState).row, event.shiftKey, event.ctrlKey, this.props.rowIndex);

            (this.state as ReactAccordionState).row[this.props.dataKey] = isExpanded;

            this.setState({
                row: (this.state as ReactAccordionState).row,
            });

            if(null != this.props.stopPropagationOnClick && this.props.stopPropagationOnClick) {
                event.stopPropagation();
            }
        }
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState(() => ({
            row: (this.state as ReactAccordionState).row,
        }));
    }

    onExpandedClick(event: any) {
        if(this.allowExpandAndCollapse) {
            const isExpanded = $(event.currentTarget).is(":checked");

            (this.state as ReactAccordionState).row[this.props.dataKey] = isExpanded;

            this.setState({
                row: (this.state as ReactAccordionState).row
            });
        }
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    startDragRow(event: React.DragEvent<HTMLTableRowElement>) {
        if (!(this.state as ReactAccordionState).disabled && this.props.enableDragAndDrop && null != (this.state as ReactAccordionState).row) {
            this.props.onDragStart(event, (this.state as ReactAccordionState).row);
        }
        event.stopPropagation();
    }

    stopDragRow(event: React.DragEvent<HTMLTableRowElement>) {
        if (!(this.state as ReactAccordionState).disabled && this.props.enableDragAndDrop) {
            this.props.onDragStop(event);
        }
    }

    duringDragRow(event: React.DragEvent<HTMLTableRowElement>) {
        if (!(this.state as ReactAccordionState).disabled && this.props.enableDragAndDrop) {
            this.props.onDuringDrag(event, (this.state as ReactAccordionState).row);
        }
        event.stopPropagation();
    }

    getAccordion(isExpanded: boolean) {
        if(this.props.title) {
            return <h3
                id={this.props.id}
                tabIndex={this.props.tabIndex}
                className={(isExpanded) ? this.props.expandedCSS : this.props.collapsedCSS}
                style={(isExpanded) ? this.props.expandedStyle : this.props.collapsedStyle}
                title={this.props.title}
            >
                <div className="flex-container-inline fillSpace" onClick={this.hideShowAccordion} >
                    <span className={this.getAccordionIcon()} style={this.props.arrowStyle}></span>
                    {this.props.text}
                </div>
            </h3>
        } else {
            return <h3
                id={this.props.id}
                tabIndex={this.props.tabIndex}
                className={(isExpanded) ? this.props.expandedCSS : this.props.collapsedCSS}
                style={(isExpanded) ? this.props.expandedStyle : this.props.collapsedStyle}
            >
                <div className="flex-container-inline fillSpace" onClick={this.hideShowAccordion} >
                    <span className={this.getAccordionIcon()} style={this.props.arrowStyle}></span>
                    {this.props.text}
                </div>
            </h3>
        }
    }

    render() {
        const isExpanded = (this.allowExpandAndCollapse) ? null != (this.state as ReactAccordionState).row[this.props.dataKey] && (this.state as ReactAccordionState).row[this.props.dataKey] : true;
        const accordionCSS = (!(this.state as ReactAccordionState).disabled && this.props.enableDragAndDrop) ? ((this.props.css.length > 0) ? (this.props.css + ' ui-draggable') : 'ui-draggable') : '';

        return <div id={this.props.shellID} className={accordionCSS} style={this.props.style} draggable={(((this.state as ReactAccordionState).disabled) ? false : this.props.enableDragAndDrop)} onDragStart={this.startDragRow} onDragEnd={this.stopDragRow} onDragEnter={this.duringDragRow}>
            {getReactButton({id: this.props.refreshID, style: {border: "0px", padding: "0px"}, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.expandedID}
                    type="checkbox"
                    onChange={this.onExpandedClick}
                    checked={isExpanded}
                /></td>
                <td>
                    HIDDEN EXPANDED CHECKBOX
                </td>
            </tr><tr>
                <td><input
                    id={this.props.disableID}
                    type="checkbox"
                    onChange={this.onDisableClick}
                    checked={(this.state as ReactAccordionState).disabled}
                /></td>
                <td>
                    HIDDEN DISABLE BUTTON
                </td>
            </tr></table>
            }
            {this.getAccordion(isExpanded)}
            <div id={this.props.id + '_expandDiv'} className = {((isExpanded) ? 'fadeIn' : 'fadeOut')}>
                <div id={this.props.id + '_contentDiv'} className={this.props.contentCSS} style={this.props.contentStyle}>
                    {(this.state as ReactAccordionState).content}
                </div>
            </div>
        </div>;
    }
}
